import Crud from '@/views/AditionalHour/Crud'
import Add from '@/views/AditionalHour/Add'

const routes = {
  path: '/aditionalHours',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/aditionalHours',
      name: 'list-aditional-hours',
      component: Crud,
    },
    {
      path: '/aditionalHours/add',
      name: 'Hora adicional',
      component: Add,
    },
    {
      path: '/aditionalHours/edit/:id?',
      name: 'Hora adicional',
      component: Add,
    },
  ],
}

export default routes
